import { render, staticRenderFns } from "./FeeUnitRow.vue?vue&type=template&id=38e5e999&"
import script from "./FeeUnitRow.vue?vue&type=script&lang=js&"
export * from "./FeeUnitRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports